<div class="body">


    <br/>
    <div class="row">

        <div class="col-lg-5"> </div>

        <div class="center">
            <h1> Afiliación </h1>
        </div>

        <div class="col-lg-4"> </div>

    </div>
    <br/>
    <div class="container principal">

        <div *ngIf="rol == 'ROLE_AFILIADO' || rol == 'ROLE_JUBILADO'">

            <div class="row">

                <div class="col-lg-5"> </div>

                <div class="col-lg-7">
                    <p> <b> Usuario: </b> {{nombreUsuario}} </p>
                </div>

            </div>

        </div>



        <div *ngIf="rol != 'ROLE_AFILIADO'" style="padding-bottom: 20px;">

            <div class="row">

                <div class="col-lg-1"> </div>

                <div class="col-lg-2">
                    <h2> Rut Afiliado </h2>
                </div>

                <div class="col-lg-4">

                    <input id="rut" name="rut" class = "form-control" [(ngModel)] = "afiliado.rut" class="form-control" type="text" required placeholder="Ingrese el RUT del afiliado. Ej: 11111111-1"  />

                </div>


                <div class="col-lg-1">

                    <button class="btn btn-primary" id="btnvalida"  (click) = "buscar(false)">
                            Buscar
                    </button>

                </div>
              
                <div class="col-lg-1 ml-1 mr-1" *ngIf="((isAdmin || isEncargadoContabilidad ) && (afiliado.tipoAfiliado=='ACTIVO'))">
                    <button class="btn btn-primary" id="btnvalida"  (click) = "actualizar(false)">
                            Actualizar   
                    </button>
                </div>
                <div class="col-lg-1 ml-1 mr-1" *ngIf="((isAdmin || isEncargadoContabilidad) &&  (accion!='agregar' && accion!='guardar')) ">
                    <button class="btn btn-primary" id="btnvalida"  (click) = "agregar()">
                            Crear    
                    </button>
                </div>

                <div class="col-lg-1 ml-1 mr-1" *ngIf="((isAdmin || isEncargadoContabilidad) &&  (accion=='agregar' && (afiliado.tipoAfiliado=='PASIVO') || accion=='guardar'))">
                    <button class="btn btn-primary" id="btnvalida"  (click) = "guardar()">
                            guardar    
                    </button>
                </div>
               

            </div>

        </div>
        <br/>

       

        <div class="row">
            <div class="col-lg-1"> </div>
           <!-- *ngIf="accion == 'guardar'" -->
            <div class="col-lg-8" *ngIf="afiliado.tipoAfiliado == 'PASIVO' ">
                <h2 style="color: #1c25a2;"> Tipo Afiliado: PENSIONADO </h2>
            </div>
            <div class="col-lg-8" *ngIf="afiliado.tipoAfiliado == 'ACTIVO' ">
                <h2 style="color: #1c25a2;"> Tipo Afiliado: ACTIVO </h2>
            </div>
            <div class="col-lg-8" *ngIf="accion == 'guardar' && !(afiliado.tipoAfiliado == 'ACTIVO' 
            || afiliado.tipoAfiliado == 'PASIVO') && (isAdmin || isEncargadoContabilidad)">
                <h2 style="color: #1c25a2;"> Tipo Afiliado: CREAR PENSIONADO</h2>
            </div>

            <div class="col-lg-8">

                <div class="col-lg-1"> </div>
                 
                <div class="col-lg-8"><!--  <label> Tipo Afiliado </label>-->
                 </div>
                
                <div class="col-lg-5">
                    <!-- 
                    <select id="paisAfiliado" name="paisAfiliado">
                        <option value="0">Activo </option>
                        <option value="1">Pasivo </option>
                      
                    </select>
                    -->
                </div>
            </div>     
            <div class="col-lg-3"> </div>
        </div>
        <br/>
        <div class="row" style="border:1px;">
            <div class="col-lg-1"> </div>
            <div class="col-lg-10" style="border-color: black;border: 1px">
                <form #usuarioForm = ngForm >
                    
                    <mat-tab-group animationDuration="0ms" dynamicHeight   mat-align-tabs = "afiliado">
                        <mat-tab>
                            <div class="tab-content">
                          
                            <ng-template let-row="afiliado" mat-tab-label>                               
                                Datos Personales                            
                            </ng-template>
                        
                            <app-afiliacion-tab1 [afiliado]="afiliado"> </app-afiliacion-tab1>
                           
                            </div>
                        </mat-tab>
                        <mat-tab>
                            <ng-template mat-tab-label>
                                Datos de Contacto
                            </ng-template>
                            <app-afiliacion-tab2 [afiliado]="afiliado"></app-afiliacion-tab2>
                        </mat-tab>                    
                        <mat-tab *ngIf="afiliado.tipoAfiliado == 'Activo' || afiliado.tipoAfiliado == 'ACTIVO';">
                            <ng-template mat-tab-label>
                                Datos Laborales
                            </ng-template>
                            <app-afiliacion-tab3 [afiliado]="afiliado"></app-afiliacion-tab3>
                        </mat-tab>
                        <mat-tab>
                            <ng-template mat-tab-label>
                                Carga Familiar
                            </ng-template>
                            <app-afiliacion-tab4 [afiliado]="afiliado"></app-afiliacion-tab4>
                        </mat-tab> 
                      
                        <mat-tab *ngIf="(accion=='guardar') || (afiliado.tipoAfiliado == 'Pasivo' || afiliado.tipoAfiliado == 'PASIVO')">
                            <ng-template mat-tab-label>
                                Datos de pensión   
                            </ng-template>
                            <app-afiliacion-tab5 [afiliado]="afiliado"></app-afiliacion-tab5>
                        </mat-tab>
                        <mat-tab>
                            <ng-template mat-tab-label>
                                Datos Bancarios
                            </ng-template>
                            <app-afiliacion-tab6 [afiliado]="afiliado"></app-afiliacion-tab6>
                        </mat-tab>
                        <mat-tab>
                            <ng-template mat-tab-label>
                                Estado Afiliación
                            </ng-template>
                            <app-afiliacion-tab7 [afiliado]="afiliado"></app-afiliacion-tab7>
                        </mat-tab>
                                         
                        <mat-tab *ngIf="(rol != 'ROLE_AFILIADO' && rol != 'ROLE_JUBILADO') && accion!='guardar'">
                            <ng-template mat-tab-label>
                                Observaciones 
                            </ng-template>
                            <app-afiliacion-tab8 [afiliado]="afiliado"></app-afiliacion-tab8>
                        </mat-tab>
                      
                        <mat-tab *ngIf="afiliado.documentos && afiliado.documentos.length > 0">
                            <ng-template mat-tab-label>
                                Documentos
                            </ng-template>
                            <app-afiliacion-tab9 [afiliado]="afiliado"></app-afiliacion-tab9>
                        </mat-tab>
                    </mat-tab-group>
                </form>
            </div>
            <div class="col-lg-1"> </div>
        </div>
        <br/>
        <!--/form-->

        <br/>
        <div *ngIf="rol != 'ROLE_AFILIADO'">
            <div class="row line">
               
                <div > </div>
              <!--
                <div class="col-lg-2 col-sm-3">
                    <div *ngIf="rol != 'ROLE_EJECUTIVO_CAIP'">
                        <button class="btn btn-danger"> 
                            
                           Rechazar solicitud
                        
                        </button>
                    </div>
                </div>
                -->
                <div class="col-lg-2 col-sm-3"> </div>
                <div class="col-lg-6 col-sm-5"> </div>
               
                <div class="col-lg-3 col-sm-3">
                    <div *ngIf="rol != 'ROLE_EJECUTIVO_CAIP'">
                        <!--
                        <button class="btn btn-success" id="btnvalida" (click) = "guardar()"> 
                           Aprobar Afiliado                        
                        </button>
                      
                        &nbsp;
                        <button class="btn btn-success" id="btnvalida" (click) = "guardar()">                            
                            Guardar                         
                        </button>
                         -->
                    </div>
                    
                </div>

          
                
            </div>
            <!--
            <div class="col-lg-1 col-sm-1"> </div>
            -->
        </div>

    </div>
</div>

<div class="container" style="height:100px"> </div>